/**
 * Impresión de etiquetas con código de barras para el catálogo de repuestos.
 * Genera una ventana lista para imprimir: el navegador deja elegir la
 * impresora instalada (térmica de etiquetas o impresora de hojas) y el
 * formato ajusta automáticamente letra, nombre, SKU y código de barras.
 */
import { barcodeSVG } from "./barcode";

export const FORMATOS = [
  { id: "t50x25", nombre: "Etiqueta térmica 50 × 25 mm", tipo: "etiqueta",
    w: 50, h: 25, fontNombre: 6.5, fontSku: 6, barraAlto: 34 },
  { id: "t38x19", nombre: "Etiqueta térmica 38 × 19 mm", tipo: "etiqueta",
    w: 38, h: 19, fontNombre: 5, fontSku: 5, barraAlto: 26 },
  { id: "carta24", nombre: "Hoja carta — 24 etiquetas (3 × 8)", tipo: "hoja",
    cols: 3, rows: 8, fontNombre: 7, fontSku: 6.5, barraAlto: 34 },
  { id: "carta10", nombre: "Hoja carta — 10 etiquetas (2 × 5)", tipo: "hoja",
    cols: 2, rows: 5, fontNombre: 9, fontSku: 8, barraAlto: 48 },
];

const esc = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;");

function etiquetaHTML(item, f) {
  const svg = barcodeSVG(item.sku, { alto: f.barraAlto, modulo: 2 });
  return `<div class="et">
    <div class="nom">${esc(item.nombre)}</div>
    <div class="bar">${svg}</div>
    <div class="sku">${esc(item.sku)}</div>
  </div>`;
}

/**
 * items: [{sku, nombre}] · formatoId: id de FORMATOS · copias: por repuesto.
 * Abre la ventana de impresión del sistema (ahí se elige la impresora).
 */
export function imprimirEtiquetas(items, formatoId, copias = 1) {
  const f = FORMATOS.find((x) => x.id === formatoId) || FORMATOS[0];
  const lista = items.filter((i) => (i.sku || "").trim());
  if (lista.length === 0) return false;
  const todas = [];
  for (const it of lista) for (let c = 0; c < Math.max(1, copias); c++) todas.push(it);

  let css, cuerpo;
  if (f.tipo === "etiqueta") {
    // una etiqueta por página (rollos térmicos)
    css = `
      @page { size: ${f.w}mm ${f.h}mm; margin: 0; }
      html,body { margin:0; padding:0; }
      .et { width:${f.w}mm; height:${f.h}mm; box-sizing:border-box; padding:1mm 1.5mm;
            display:flex; flex-direction:column; justify-content:space-between;
            align-items:center; page-break-after:always; overflow:hidden; }
      .nom { font-size:${f.fontNombre}pt; font-weight:bold; text-align:center; width:100%;
             white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
      .bar { flex:1; width:96%; display:flex; align-items:center; min-height:0; }
      .bar svg { width:100%; height:100%; }
      .sku { font-size:${f.fontSku}pt; font-family:monospace; letter-spacing:0.5px; }`;
    cuerpo = todas.map((i) => etiquetaHTML(i, f)).join("");
  } else {
    // grilla en hoja carta (etiquetas autoadhesivas o papel normal)
    css = `
      @page { size: letter; margin: 10mm; }
      html,body { margin:0; padding:0; }
      .grid { display:grid; grid-template-columns:repeat(${f.cols},1fr); gap:2mm; }
      .et { border:0.3mm dashed #bbb; box-sizing:border-box; padding:1.5mm 2mm;
            height:${(260 - 10 * f.rows) / f.rows}mm; display:flex; flex-direction:column;
            justify-content:space-between; align-items:center; overflow:hidden;
            break-inside:avoid; }
      .nom { font-size:${f.fontNombre}pt; font-weight:bold; text-align:center; width:100%;
             white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
      .bar { flex:1; width:94%; display:flex; align-items:center; min-height:0; }
      .bar svg { width:100%; height:100%; }
      .sku { font-size:${f.fontSku}pt; font-family:monospace; letter-spacing:0.5px; }`;
    cuerpo = `<div class="grid">${todas.map((i) => etiquetaHTML(i, f)).join("")}</div>`;
  }

  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return false;
  win.document.write(`<!doctype html><html><head><meta charset="utf-8">
    <title>Etiquetas Odontofix (${todas.length})</title>
    <style>body{font-family:Arial,Helvetica,sans-serif}${css}</style>
    </head><body>${cuerpo}
    <script>window.onload = function(){ window.focus(); window.print(); };</scr${""}ipt>
    </body></html>`);
  win.document.close();
  return true;
}
